import React from 'react'
import './CardStep.scss'
const CardStep = ({step,title,image}) => {
    return (
        <div className="item-tab">
            <div className="content-item">
                <span>{step}</span>
                <p>{title}</p>
            </div>
            <div className="content-item-img">
                <img src={image} alt="" />
            </div>
        </div>
    )
}

export default CardStep